export default "__VITE_ASSET__CB8$LBKu__"